module.exports = __webpack_public_path__ + "img/product-preview-57.b626da6.png";